import React, { useState, useEffect } from 'react';
import api from '../api/client';

const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 14, marginBottom: 12, boxSizing: 'border-box', outline: 'none', display: 'block' };
const btnPrimary = { padding: '8px 16px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 500, fontSize: 13, cursor: 'pointer' };
const btnGhost = { padding: '7px 12px', background: 'none', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#555' };
const btnDanger = { padding: '7px 12px', background: 'none', border: '1px solid #c0392b', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#c0392b' };

export default function Scripts() {
  const [scripts, setScripts] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', content: '' });
  const load = async () => { const { data } = await api.get('/agents/scripts'); setScripts(data); };
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (editing === 'new') await api.post('/agents/scripts', form);
    else await api.put(`/agents/scripts/${editing.id}`, form);
    setEditing(null); await load();
  };
  const del = async (id, name) => {
    if (!window.confirm(`Удалить скрипт «${name}»?`)) return;
    await api.delete(`/agents/scripts/${id}`); await load();
  };

  if (editing !== null) return (
    <div style={{ padding: 32, maxWidth: 800 }}>
      <button onClick={() => setEditing(null)} style={btnGhost}>← Назад</button>
      <h2 style={{ fontSize: 18, fontWeight: 600, margin: '16px 0 20px' }}>{editing === 'new' ? 'Новый скрипт' : `Редактировать: ${editing.name}`}</h2>
      <input placeholder="Название" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={inp} />
      <textarea value={form.content} onChange={e => setForm(f => ({ ...f, content: e.target.value }))} rows={20} style={{ ...inp, fontFamily: 'monospace', fontSize: 13, resize: 'vertical' }} />
      <div style={{ display: 'flex', gap: 8 }}><button onClick={save} style={btnPrimary}>Сохранить</button><button onClick={() => setEditing(null)} style={btnGhost}>Отмена</button></div>
    </div>
  );

  return (
    <div style={{ padding: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>Скрипты</h1>
        <button onClick={() => { setForm({ name: '', content: 'Ты вежливый ассистент. Отвечай на русском языке.' }); setEditing('new'); }} style={btnPrimary}>+ Новый скрипт</button>
      </div>
      {scripts.length === 0 && <div style={{ textAlign: 'center', padding: 60, color: '#aaa', fontSize: 14 }}>Скриптов нет.</div>}
      <div style={{ display: 'grid', gap: 10 }}>
        {scripts.map(s => (
          <div key={s.id} style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 10, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 20 }}>📝</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 500, fontSize: 14 }}>{s.name}</div>
              <div style={{ fontSize: 12, color: '#aaa', fontFamily: 'monospace', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 600 }}>{s.content.slice(0, 120)}...</div>
            </div>
            <button onClick={() => { setForm({ name: s.name, content: s.content }); setEditing(s); }} style={btnGhost}>Редактировать</button>
            <button onClick={() => del(s.id, s.name)} style={btnDanger}>🗑</button>
          </div>
        ))}
      </div>
    </div>
  );
}
